<script setup lang="ts">
import { useTimeoutFn } from '@vueuse/core'

defineProps({
  isError: {
    type: Boolean,
    default: false
  }
})

const isMounted = ref(false)

onMounted(() => {
  useTimeoutFn(() => {
    isMounted.value = true
  }, 300)
})
</script>

<template>
  <span class="absolute bottom-0 left-0 h-0.5 w-full overflow-hidden">
    <span
      class="absolute left-[-200%] top-0 flex h-full w-[200%] transition-all duration-700 ease-quart-out"
      :class="{ 'translate-x-full': isError, 'translate-x-1/2': isMounted }"
    >
      <span class="flex-1 bg-gradient-to-r from-pink via-purple to-cyan"></span>
      <span class="flex-1 bg-white"></span>
    </span>
  </span>
</template>
